import type { Series } from '../types';

export function getSeriesItemUrl(series: Series): string {
  return series.localized_path;
}
